import httpbaseConfig from "../../baseConfig/config";
import { isPwa } from "@/utils/utils";
// getters
const getters = {
  userInfo: state => {
    return state.user;
  },
  authData: state => {
    if (!state.user) {
      return null;
    }
    if (!state.user.token || !state.user.secretKey) {
      return null;
    }
    return {
      token: state.user.token,
      secretKey: state.user.secretKey
    };
  },
  getPlatfrom: state => {
    if(isPwa()){
      return 13
    } else {
      return state.platform;
    }
  },
  country: state => {
    let country = state.user.country;
    let isExsite = false;
    for (let i in httpbaseConfig.countryList) {
      if (httpbaseConfig.countryList[i].key == country) {
        isExsite = true;
      }
    }
    if (!isExsite) {
      country = httpbaseConfig.defaultCountry;
    }
    return country;
  },
  getDepositMoney: state => {
    return state.depositMoney;
  },
  getUriParams: state => {
    return state.uriParams;
  },
  cardList: state => {
    return state.cardList;
  },
  tabList: state => {
    return state.tabList;
  },
  amountList: state => {
    return state.amountList;
  },
  backEeventStatus:state => {
    return state.backEeventStatus;
  },
  depositGiftStatus: state => {
    return state.depositGiftStatus;
  },
  depositGiftList: state => { 
    return state.depositGiftList;
  },
  depositGiftRate: state => {
    return state.depositGiftRate;
  },
  max: state => state.max,
  min: state => state.min,
  depositResult: state => state.depositResult,
  withdrawResult: state => state.withdrawResult
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/actions/getters.js